<template>
    <div>
        <CModal @close="closePaymentPmodal" footer modalIsLarge>
            <template v-slot:title>
                <h5>View Transaction</h5>
            </template>
            <template v-slot:body>
                <div class="row">
                    <div class="col-md-6">
                        <div
                            class="transaction-details"
                            v-for="(value, name, index) in transaction.readable"
                            :key="index"
                            >
                            <KeyValue
                                :objKey="name"
                                :objValue="value"
                                :showCurrency="name === 'Amount'"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">

                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <button @click.prevent="closePaymentPmodal" class="btn btn-secondary">
                    Cancel
                </button>
            </template>
        </CModal>
    </div>
</template>

<script>
import CModal from "./CModal.vue";
import KeyValue from "./KeyValue.vue";
export default {
    name: "TransactionGlanceComponent",
    components: {
        CModal,
        KeyValue
    },
    props: {
        transaction: {
            required: true
        },

    },
    data() {
        return {
        };
    },
    methods: {
        closePaymentPmodal() {
            this.$emit("close");
        }
    }
};
</script>

<style></style>
